import { FormControl, Table } from "react-bootstrap";
import styled from "styled-components";
import { columnMap } from "./column-map";

export const TableWrapper = styled(Table)`
    & > tbody > tr > td {
        vertical-align: middle;
    }
`;

interface IProps {
    columnsFromFile: string[],
    assignedColumns:string[],
    sampleRow: string[],
    hasColumnHeaders: boolean,
    onHasColumnHeadersChange: (hasColumnHeaders: boolean) => void,
    onAssignedColumnChange: (index: number, column: string) => void
}

const ColumnMapping = (props: IProps) => {
    return (
        <div style={{ padding: 20 }}>
            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                <div style={{ marginRight: 10 }}>First row contain column headers?</div>
                <div>
                    <label className='radio-inline'>
                        <input
                            type='radio'
                            id='hasColumnHeadersYes'
                            name="hasColumnHeaders"
                            checked={props.hasColumnHeaders}
                            onClick={() => props.onHasColumnHeadersChange(true)}
                        /> Yes
                    </label>
                    <label className='radio-inline'>
                        <input
                            type='radio'
                            id='hasColumnHeadersNo'
                            name="hasColumnHeaders"
                            checked={!props.hasColumnHeaders}
                            onClick={() => props.onHasColumnHeadersChange(false)}
                        /> No
                    </label>
                </div>
            </div>

            <TableWrapper condensed bordered>
                <thead>
                    <tr>
                        <th style={{ width: '30%' }}>Column From File</th>
                        <th>First Row of Data</th>
                        <th>Map To</th>
                    </tr>
                </thead>
                <tbody>
                    {props.columnsFromFile.map((column, index) => {
                        return (
                            <tr key={'col-' + index}>
                                <td>{props.hasColumnHeaders ? column : `Column ${index + 1}`}</td>
                                <td>{props.sampleRow[index]}</td>
                                <td>
                                    <FormControl
                                        componentClass='select'
                                        value={props.assignedColumns[index]}
                                        onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => props.onAssignedColumnChange(index, e.currentTarget.value)}
                                    >
                                        <option value={-1}>- Assign Column -</option>
                                        {columnMap.map((mapColumn, colMapIndex) =>
                                            <option key={'colmap-' + colMapIndex} value={mapColumn.name}>{mapColumn.name}</option>
                                        )}
                                    </FormControl>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </TableWrapper>
        </div>
    );
}

export default ColumnMapping;